/**
 * Same rules as backend `requestCancellationEligibility.ts`:
 * cancel only before `automation_started` appears in the audit timeline.
 */

const TIMELINE_STEPS_IN_ORDER = [
  'backstage_ticket_created',
  'service_now_ticket_created',
  'automation_started',
  'automation_completed',
  'service_now_ticket_closed',
  'access_provisioning_completed',
] as const;

const STEP_SET = new Set<string>(TIMELINE_STEPS_IN_ORDER);

const EVENT_ALIASES: Record<string, (typeof TIMELINE_STEPS_IN_ORDER)[number]> = {
  service_now_ticket_updated: 'service_now_ticket_created',
  servicenow_ticket_created: 'service_now_ticket_created',
  servicenow_ticket_updated: 'service_now_ticket_created',
};

function normalizeEventKey(name: unknown): string {
  return String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

function canonicalTimelineStep(eventName: unknown): string | null {
  const key = normalizeEventKey(eventName);
  if (!key) return null;
  const mapped = EVENT_ALIASES[key];
  const canonical = mapped ?? key;
  return STEP_SET.has(canonical) ? canonical : null;
}

const CANCEL_CUTOFF_STEP_INDEX = 2;

export function userCancellationAllowedByTimeline(
  events: ReadonlyArray<{ event?: string }> | undefined,
): boolean {
  const reached = new Set<string>();
  for (const row of events ?? []) {
    const c = canonicalTimelineStep(row.event);
    if (c) reached.add(c);
  }
  for (let i = CANCEL_CUTOFF_STEP_INDEX; i < TIMELINE_STEPS_IN_ORDER.length; i++) {
    if (reached.has(TIMELINE_STEPS_IN_ORDER[i])) return false;
  }
  return true;
}
